module.exports = __webpack_public_path__ + "static/media/06.22e5a65c.mp3";